<default-header *ngIf="isAuthenticated" [AppName]="'APP-NAME'"
 [BazaZnanjaLink]="bazaZnanjaLink" [LogoLink]="logoLink"></default-header>
<!-- <notifier-container></notifier-container> -->
<!-- <simple-notifications></simple-notifications> -->
<yt-loader></yt-loader>
<div class="main-content">
    <!-- <yt-fw-side-menu [IsTransparent]="false"></yt-fw-side-menu> -->
    <yt-side-menu-v2 *ngIf="isAuthenticated"></yt-side-menu-v2>
    <!-- <a  routerLink = "admin/userrole">user role</a> -->
    <!-- <yt-breadcrumbs></yt-breadcrumbs> -->
    <router-outlet></router-outlet>
</div>
<default-footer>
    <span class="text-right">{{ 'APP.FOOTER.COPYRIGHT' | translate }}</span>
</default-footer>